import type { ReactNode } from "react";

interface HTMLGalleryProps {
	title?: string;
	children?: ReactNode;
}

const HTMLGallery = ({ title, children }: HTMLGalleryProps) => (
	<div data-component="gallery">
		{children}
		{title && <em>{title}</em>}
	</div>
);

export default HTMLGallery;
